import { render, staticRenderFns } from "./BeforeUpdate.vue?vue&type=template&id=3290810a&"
import script from "./BeforeUpdate.vue?vue&type=script&lang=js&"
export * from "./BeforeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports